export const isLoadingAvailabilities = (state) => state.fetchAvailabilities.loading;
export const selectFetchAvailabilitiesAvailabilities = (state) => state.fetchAvailabilities.availabilities;

export const isLoadingAvailabilitiesDms = (state) => state.fetchAvailabilitiesDms.loading;
export const selectFetchAvailabilitiesDms = (state) => state.fetchAvailabilitiesDms;
